import React, { FC, useEffect } from "react";
import { createPortal } from "react-dom";

interface DeletePostConfirmModalProps {
  close: () => void;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  onConfirmAction: () => void | Promise<void>;
  isDanger?: boolean;
}

const DeletePostConfirmModal: FC<DeletePostConfirmModalProps> = ({
  close,
  title = "Delete Post",
  message = "Are you sure you want to delete this post? This action cannot be undone.",
  confirmText = "Delete",
  cancelText = "Cancel",
  onConfirmAction,
  isDanger = true,
}) => {
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") close();
    };

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [close]);

  return createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      onMouseDown={close}
    >
      <div className="absolute inset-0 bg-black/40" />

      <div
        onMouseDown={(e) => e.stopPropagation()}
        className="relative bg-gray-50 rounded-md shadow-md w-full max-w-md px-8 py-6"
      >
        <h2 className="text-xl font-bold text-purple-600 mb-4 text-center">
          {title}
        </h2>

        <p className="text-gray-500 text-sm mb-8 text-center leading-relaxed">
          {message}
        </p>

        <div className="flex gap-3">
          <button
            onClick={close}
            className="flex-1 bg-transparent hover:bg-[#d7d7fc] text-base border-purple-600 border text-purple-600 font-semibold py-2.5 rounded-md transition"
          >
            {cancelText}
          </button>

          <button
            onClick={async () => {
              await onConfirmAction();
              close();
            }}
            className={`flex-1 text-white font-semibold text-base py-2.5 rounded-md transition border ${
              "bg-purple-600 text-white font-semibold text-base py-2.5 rounded-md transition hover:bg-[#d7d7fc] hover:text-[#7650e3] border border-purple-600"
            }`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default DeletePostConfirmModal;
